import { TFunction } from 'react-i18next'
import * as yup from 'yup'

export const createWalletSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object({
    currency: yup.string().required(),
    description: yup.string().required(t('walletNameRequired')).max(40, t('walletNameLengthError')),
    profileId: yup.string().optional(),
  })
}
